export const common = {
  // Brand
  brandName: 'EachTeach',

  // Language names (LanguageSwitcher)
  languageName: 'English',
  changeLanguage: 'Change language',

  // Navbar
  nav: {
    home: 'Home',
    courseFlow: 'Course Flow',
    services: 'Services & Tools',
    register: 'Join Community',
    menu: 'Menu',
  },

  // Footer
  footer: {
    mission:
      'A community where individual language tutors and experts learn together and raise the quality of education. Making "teaching" freer and more accessible.',
    community: 'Community',
    communityRegister: 'Join Community',
    services: 'Services & Tools',
    about: 'About',
    aboutEachTeach: 'About EachTeach',
    philosophy: 'Philosophy & Mission',
    allRightsReserved: 'All rights reserved.',
  },

  // Shared actions / states
  close: 'Close',
  cancel: 'Cancel',
  submit: 'Submit',
  submitting: 'Submitting...',
  loading: 'Loading...',
  required: 'Required',
  optional: 'Optional',
};
